const getters = {
    permission_routes: state => state.permission.routes,
    settings_routes: state => state.permission.settingsRoutes,
    SessionId: state => state.session.SessionId,
    token: state => state.session.token,
    role_name: state => state.permission.role_name,
    theme_name: state => state.permission.theme_name,
    isallowedroutes: state => state.permission.isallowedroutes,
    org_details: state => state.permission.org_details,
    inv_settings_details: state => state.permission.inv_settings_details,
    print_settings_details: state => state.permission.print_settings_details,
    quot_settings_details: state => state.permission.quot_settings_details,
    cus_settings_details: state => state.permission.cus_settings_details,
    vdr_settings_details: state => state.permission.vdr_settings_details,
    crdt_settings_details: state => state.permission.crdt_settings_details,
    pdt_settings_details: state => state.permission.pdt_settings_details,
    cus_adv_settings_details: state => state.permission.cus_adv_settings_details,
    pymnt_settings_details: state => state.permission.pymnt_settings_details,
    retainer_settings_details: state => state.permission.retainer_settings_details,
    rec_inv_settings_details: state => state.permission.rec_inv_settings_details,
    amc_settings_details: state => state.permission.amc_settings_details,
    general_settings_details: state => state.permission.general_settings_details,
    primary_warehouse_details: state => state.permission.primary_warehouse_details,
    network_error: state => state.general.network_error,
    orgCurrency: state => state.permission.orgCurrency,
    org_currency_id: state => state.permission.org_currency_id,
    orgCurrencySymbol: state => state.permission.orgCurrencySymbol,
    vendor_deposit_settings_details: state => state.permission.vendor_deposit_settings_details,
    reporting_tags: state => state.permission.reporting_tags


}
export default getters